@if(showLabel()) {
    <div class="dx-field-item-label-location-top dx-field-item-label-text">{{label()}}</div>
}

<div class="h-100 w-100 d-flex align-items-center"
    [ngClass]="allowUpload() ? 'border border-dashed rounded bg-light-subtle p-3' : ''"
    appFileDragAndDrop #dragAndDrop="appFileDragAndDrop"
    [allowedFileExtensions]="[]" [enabled]="canUpload()"
    [allowedContentTypes]="allowedContentTypes()" [maxFileSize]="currentAvailableMegaBytes()"
    [showBorders]="false" (filesChange)="onFileDrop($event)"
>
    @if(allowUpload()) {
        <div
            class="flex-grow-1 d-flex flex-column align-items-center justify-content-center h-100"
        >
            @if (canUpload()) {
                <span>
                    <strong>{{'COMMON.FILE_LIST.LABEL_DRAG_AND_DROP1' | translate}}</strong>
                    {{'COMMON.LABEL_OR' | translate}}
                    <a href="#" role="button" class="text-decoration-underline" (click)="$event.preventDefault(); dragAndDrop.openFileDialog()"><strong>{{'COMMON.FILE_LIST.LABEL_DRAG_AND_DROP2' | translate}}</strong></a>
                </span>
            }
            @else {
                <strong class="text-muted">
                    {{'COMMON.FILE_LIST.LABEL_MAX_REACHED' | translate}}
                </strong>
            }
            <span class="fw-light" [ngClass]="{'text-danger': currentTotalBytes() >= maxTotalBytes()}">
                {{'COMMON.FILE_LIST.LABEL_MAX_FILE_TOTAL_SIZE' | translate}}  <b>{{ currentTotalBytes() | humanizeBytes }}</b> / <b>{{ maxTotalBytes() | humanizeBytes }}</b>
            </span>
            <span class="fw-light" [ngClass]="{'text-danger': currentTotalFiles() >= maxTotalFiles()}">
                {{'COMMON.FILE_LIST.LABEL_MAX_FILE_COUNT' | translate}} <b>{{ currentTotalFiles() }}</b> / <b>{{ maxTotalFiles() }}</b>
            </span>
            <span class="text-muted fw-light">
                {{'COMMON.FILE_LIST.LABEL_ALLOWED_FILE_TYPES' | translate}} <b>{{ allowedContentTypesString().join(', ') || 'All' }}</b>
            </span>
        </div>
    }
    @else if($files().length === 0) {
        <div
            class="flex-grow-1 d-flex flex-column justify-content-center h-100"
        >
            <span class="text-muted fw-light">
                {{'COMMON.FILE_LIST.LABEL_NO_FILES' | translate}}
            </span>
        </div>

    }

    @if(visibleFiles().length > 0) {
        <dx-list
            [ngClass]="allowUpload() ? 'border-start ps-3 ms-3 w-50' : 'w-100'"
            [dataSource]="visibleFiles()"
        >
            <div class="p-0 pb-1" *dxTemplate="let file of 'item'">

                <div class="p-2 border shadow-sm d-flex align-items-center">
                    <div class="flex-grow-0 px-2">
                        <!-- ICON -->
                        <div
                            class="d-flex flex-column align-items-center justify-content-center h-100"
                        >
                            @let iconMap = getIconByMIME(file.contentType);
                            <i title="{{iconMap.mimeType}}" class="{{iconMap.iconClass}}" style="font-size: 32px;"></i>
                        </div>
                    </div>
                    <div class="flex-grow-1 px-2 text-truncate">
                        <div class="d-flex flex-column align-items-start justify-content-center w-100 text-truncate">
                            <span class="text-truncate" title="{{file.name}}">
                                {{ file.name }}
                            </span>
                            <span class="text-muted">
                                {{ file.size | humanizeBytes }}
                            </span>
                        </div>
                    </div>

                    <div class="flex-grow-0 px-2">
                        <div class="d-flex align-items-center justify-content-end gap-1">
                            @if (file.isRemote) {
                                @if (file.downloadUrl && allowDownload()) {
                                     <dx-button
                                        icon="download"
                                        stylingMode="outlined"
                                        hint="{{'COMMON.ACTION_DOWNLOAD' | translate}}"
                                        (click)="downloadFile(file)"
                                    ></dx-button>
                                }
                                @if (file.deleteUrl && allowDelete()) {
                                    <dx-button
                                        icon="trash"
                                        stylingMode="outlined"
                                        type="danger"
                                        hint="{{'COMMON.ACTION_DELETE' | translate}}"
                                        (click)="deleteFile(file)"
                                    ></dx-button>
                                }
                            }
                            @else {
                                @if (allowCancelLocal()) {
                                    <dx-button
                                        icon="close"
                                        stylingMode="outlined"
                                        hint="{{'COMMON.ACTION_CANCEL' | translate}}"
                                        (click)="cancelLocalFile(file)"
                                    ></dx-button>
                                }
                            }
                        </div>

                    </div>
                </div>
            </div>

        </dx-list>
    }
</div>

@if ($loadIndicatorVisible()) {
    <app-load-indicator />
}
